import React from 'react'
import { NavLink } from 'react-router-dom'
import appLogo from '../images/logo.png'
import Logout from './user/Logout';
import { AuthUserContext } from './session';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { faKey } from '@fortawesome/free-solid-svg-icons';

const Navigation = () => {
    return (
        <nav className="navbar navbar-dark bg-dark">
            <NavLink className="navbar-brand" to="/">
                <img src={appLogo} width="30" height="30" className="d-inline-block align-top mr-2" alt="" />
                Adosac Admin
            </NavLink>

            <AuthUserContext.Consumer>
                {authUser =>
                    authUser ? <NavigationAuth /> : <NavigationNonAuth />
                }
            </AuthUserContext.Consumer>

        </nav>
    );
}

const NavigationAuth = () => (
    <ul className="nav justify-content-end ">
        <li className="nav-item">
            <NavLink className="nav-link active text-light" to="/news">Noticias</NavLink>
        </li>
        <li className="nav-item">
            <NavLink className="nav-link active text-light" to="/offers">Comisión de Ofrecimiento</NavLink>
        </li>
        <li className="">
            <NavLink className="nav-link active text-light" to="/messages">Mensajes</NavLink>
        </li>
        <li className="nav-item">
            <NavLink className="nav-link active text-light" to="/legislation">Legislación</NavLink>
        </li>
        <li className="nav-item">
            <NavLink className="nav-link active text-light" to="/institutional">Institucional</NavLink>
        </li>
        <li className="nav-item">
            <NavLink className="nav-link active text-light" to="/junta" >Juntas</NavLink>
        </li>
        <li className="nav-item">
            <NavLink className="nav-link active text-light" to="/regimen" >Régimen</NavLink>
        </li>
        <li className="nav-item dropdown ">
            <a className=" nav-link dropdown-toggle text-light" href="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                <FontAwesomeIcon className="mr-1" icon={faUser} />
                Usuario
            </a>
            <div className="dropdown-menu dropdown-menu-right">
                <NavLink className="dropdown-item" to='/passwordchange'>
                    <FontAwesomeIcon className="mr-1" icon={faKey} />
                    Cambiar Contraseña
                </NavLink>
                <div className="dropdown-divider" />
                <Logout />
            </div>
        </li>
    </ul>
);

const NavigationNonAuth = () => (
    <ul className="nav justify-content-end">
        <li className="nav-item">
            <NavLink className="nav-link active text-light" to="/login">Iniciar Sesión</NavLink>
        </li>
    </ul>
);

export default Navigation;